// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/admin_credit.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/admin_credit.proto.
 */
export const file_api_proto_v1_admin_credit: GenFile = /*@__PURE__*/
  fileDesc("Ch9hcGlfcHJvdG8vdjEvYWRtaW5fY3JlZGl0LnByb3RvEgxhcGlfcHJvdG8udjEiLQoXR2V0Q29tcGFueUNyZWRpdFJlcXVlc3QSEgoKY29tcGFueV9pZBgBIAEoAyLKAQoYR2V0Q29tcGFueUNyZWRpdFJlc3BvbnNlEjEKB2JhbGFuY2UYASABKAsyIC5hcGlfcHJvdG8udjEuQWRtaW5DcmVkaXRCYWxhbmNlEioKBGxvdHMYAiADKAsyHC5hcGlfcHJvdG8udjEuQWRtaW5DcmVkaXRMb3QSSQoUdXBjb21pbmdfZXhwaXJhdGlvbnMYAyADKAsyKy5hcGlfcHJvdG8udjEuQWRtaW5DcmVkaXRVcGNvbWluZ0V4cGlyYXRpb25KBAgEEAUirgEKEkFkbWluQ3JlZGl0QmFsYW5jZRIRCgl1bml2ZXJzYWwYASABKAMSPAoJZGVkaWNhdGVkGAIgAygLMikuYXBpX3Byb3RvLnYxLkFkbWluQ3JlZGl0RGVkaWNhdGVkQmFsYW5jZRINCgV0b3RhbBgEIAEoAxIVCg1leHBpcmluZ19zb29uGAUgASgDEhsKE2V4cGlyaW5nX3Nvb25fdW50aWwYBiABKAlKBAgDEAQiSQobQWRtaW5DcmVkaXREZWRpY2F0ZWRCYWxhbmNlEhcKD3Blcm1pc3Npb25fY29kZRgBIAEoCRIRCglyZW1haW5pbmcYAiABKAMisgIKDkFkbWluQ3JlZGl0TG90EgoKAmlkGAEgASgJEhMKC2NyZWRpdF90eXBlGAIgASgJEiEKGWRlZGljYXRlZF9wZXJtaXNzaW9uX2NvZGUYAyABKAkSFgoOZ3JhbnRlZF9hbW91bnQYBCABKAMSGAoQcmVtYWluaW5nX2Ftb3VudBgFIAEoAxIUCgxncmFudF9zb3VyY2UYBiABKAkSDgoGcmVhc29uGAcgASgJEhoKEnNvdXJjZV9jb250cmFjdF9pZBgIIAEoCRIbChNhcHByb3ZhbF9yZXF1ZXN0X2lkGAkgASgJEhIKCmV4cGlyZXNfYXQYCiABKAkSEgoKZXhwaXJlc19vbhgNIAEoCRISCgpyZXZva2VkX2F0GAsgASgJEg8KB2NyZWF0ZWQYDCABKAkiQwodQWRtaW5DcmVkaXRVcGNvbWluZ0V4cGlyYXRpb24SEgoKZXhwaXJlc19vbhgBIAEoCRIOCgZhbW91bnQYAiABKAMiXgolTGlzdENvbXBhbnlDcmVkaXRMZWRnZXJFbnRyaWVzUmVxdWVzdBISCgpjb21wYW55X2lkGAEgASgDEhEKCXBhZ2Vfc2l6ZRgCIAEoBRIOCgZjdXJzb3IYAyABKAkidAomTGlzdENvbXBhbnlDcmVkaXRMZWRnZXJFbnRyaWVzUmVzcG9uc2USNQoHZW50cmllcxgBIAMoCzIkLmFwaV9wcm90by52MS5BZG1pbkNyZWRpdExlZGdlckVudHJ5EhMKC25leHRfY3Vyc29yGAIgASgJIrUBChZBZG1pbkNyZWRpdExlZGdlckVudHJ5EhMKC29jY3VycmVkX2F0GAEgASgJEgwKBGtpbmQYAiABKAkSFwoPcGVybWlzc2lvbl9jb2RlGAMgASgJEg4KBmFtb3VudBgEIAEoAxISCgpzdGFmZl9uYW1lGAUgASgJEhMKC2Rlc2NyaXB0aW9uGAYgASgJEhMKC3RhcmdldF90eXBlGAcgASgJEhEKCXRhcmdldF9pZBgIIAEoCUIzWjFnaXRodWIuY29tL2gtc2NhcGUvaWVzYXB1cmkvZ28vYXBpX3Byb3RvL3YxO2FwaXYxYgZwcm90bzM");

/**
 * @generated from message api_proto.v1.GetCompanyCreditRequest
 */
export type GetCompanyCreditRequest = Message<"api_proto.v1.GetCompanyCreditRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;
};

/**
 * Describes the message api_proto.v1.GetCompanyCreditRequest.
 * Use `create(GetCompanyCreditRequestSchema)` to create a new message.
 */
export const GetCompanyCreditRequestSchema: GenMessage<GetCompanyCreditRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_credit, 0);

/**
 * @generated from message api_proto.v1.GetCompanyCreditResponse
 */
export type GetCompanyCreditResponse = Message<"api_proto.v1.GetCompanyCreditResponse"> & {
  /**
   * 残高（credit.Balance の導出値）
   *
   * @generated from field: api_proto.v1.AdminCreditBalance balance = 1;
   */
  balance?: AdminCreditBalance;

  /**
   * 付与ロットの全履歴（無効化済み・期限切れを含む。有効期限の近い順）
   *
   * @generated from field: repeated api_proto.v1.AdminCreditLot lots = 2;
   */
  lots: AdminCreditLot[];

  /**
   * 今日から 3 か月以内に失効する消費可能クレジット（失効日ごとの集計・日付の近い順）
   *
   * @generated from field: repeated api_proto.v1.AdminCreditUpcomingExpiration upcoming_expirations = 3;
   */
  upcomingExpirations: AdminCreditUpcomingExpiration[];
};

/**
 * Describes the message api_proto.v1.GetCompanyCreditResponse.
 * Use `create(GetCompanyCreditResponseSchema)` to create a new message.
 */
export const GetCompanyCreditResponseSchema: GenMessage<GetCompanyCreditResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_credit, 1);

/**
 * 企業の残高（credit.Balance）。専用・汎用を分けて返す
 *
 * @generated from message api_proto.v1.AdminCreditBalance
 */
export type AdminCreditBalance = Message<"api_proto.v1.AdminCreditBalance"> & {
  /**
   * 汎用クレジットの残量
   *
   * @generated from field: int64 universal = 1;
   */
  universal: bigint;

  /**
   * 機能専用の残量（残量 0 の機能は含めない）
   *
   * @generated from field: repeated api_proto.v1.AdminCreditDedicatedBalance dedicated = 2;
   */
  dedicated: AdminCreditDedicatedBalance[];

  /**
   * 専用の全機能分 + 汎用
   *
   * @generated from field: int64 total = 4;
   */
  total: bigint;

  /**
   * expiring_soon_until までに失効する消費可能クレジットの合計
   *
   * @generated from field: int64 expiring_soon = 5;
   */
  expiringSoon: bigint;

  /**
   * 当月末 24:00（RFC3339）
   *
   * @generated from field: string expiring_soon_until = 6;
   */
  expiringSoonUntil: string;
};

/**
 * Describes the message api_proto.v1.AdminCreditBalance.
 * Use `create(AdminCreditBalanceSchema)` to create a new message.
 */
export const AdminCreditBalanceSchema: GenMessage<AdminCreditBalance> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_credit, 2);

/**
 * 機能専用クレジットの残量 1 件
 *
 * @generated from message api_proto.v1.AdminCreditDedicatedBalance
 */
export type AdminCreditDedicatedBalance = Message<"api_proto.v1.AdminCreditDedicatedBalance"> & {
  /**
   * ai.color_simulation / ai.area_estimation / ai.survey_report
   *
   * @generated from field: string permission_code = 1;
   */
  permissionCode: string;

  /**
   * @generated from field: int64 remaining = 2;
   */
  remaining: bigint;
};

/**
 * Describes the message api_proto.v1.AdminCreditDedicatedBalance.
 * Use `create(AdminCreditDedicatedBalanceSchema)` to create a new message.
 */
export const AdminCreditDedicatedBalanceSchema: GenMessage<AdminCreditDedicatedBalance> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_credit, 3);

/**
 * 付与ロット 1 件（credit_lots テーブル）
 *
 * @generated from message api_proto.v1.AdminCreditLot
 */
export type AdminCreditLot = Message<"api_proto.v1.AdminCreditLot"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * universal / dedicated
   *
   * @generated from field: string credit_type = 2;
   */
  creditType: string;

  /**
   * 機能専用ロットの対象機能。汎用ロットは空文字
   *
   * @generated from field: string dedicated_permission_code = 3;
   */
  dedicatedPermissionCode: string;

  /**
   * 付与量
   *
   * @generated from field: int64 granted_amount = 4;
   */
  grantedAmount: bigint;

  /**
   * 残量（付与量 - 有効な割当）。無効化・期限切れでも実数を返す
   *
   * @generated from field: int64 remaining_amount = 5;
   */
  remainingAmount: bigint;

  /**
   * plan_yearly / plan_monthly / trial / manual
   *
   * @generated from field: string grant_source = 6;
   */
  grantSource: string;

  /**
   * 付与理由の自由記述（手動付与では必須）
   *
   * @generated from field: string reason = 7;
   */
  reason: string;

  /**
   * 由来契約（ULID）。無ければ空文字
   *
   * @generated from field: string source_contract_id = 8;
   */
  sourceContractId: string;

  /**
   * 由来の承認申請（ULID）。無ければ空文字
   *
   * @generated from field: string approval_request_id = 9;
   */
  approvalRequestId: string;

  /**
   * 失効日時（RFC3339）。この時刻ちょうどから消費できない（排他的な境界）
   *
   * @generated from field: string expires_at = 10;
   */
  expiresAt: string;

  /**
   * 有効な最終日（YYYY-MM-DD・JST）。expires_at の直前の瞬間の日付で、この日いっぱいは消費できる。
   * expires_at をそのまま日付にすると画面が 1 日先にズレるため、表示にはこちらを使う
   * （手動付与では申請時に入力した expires_on と一致する）
   *
   * @generated from field: string expires_on = 13;
   */
  expiresOn: string;

  /**
   * 無効化日時（RFC3339）。有効なロットは空文字
   *
   * @generated from field: string revoked_at = 11;
   */
  revokedAt: string;

  /**
   * 付与日時（RFC3339）
   *
   * @generated from field: string created = 12;
   */
  created: string;
};

/**
 * Describes the message api_proto.v1.AdminCreditLot.
 * Use `create(AdminCreditLotSchema)` to create a new message.
 */
export const AdminCreditLotSchema: GenMessage<AdminCreditLot> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_credit, 4);

/**
 * 失効予定 1 日分（消費可能ロットを失効日ごとに集計したもの）。
 * 体験ロットの番兵期限（決定53）は集計対象外
 *
 * @generated from message api_proto.v1.AdminCreditUpcomingExpiration
 */
export type AdminCreditUpcomingExpiration = Message<"api_proto.v1.AdminCreditUpcomingExpiration"> & {
  /**
   * 有効な最終日（YYYY-MM-DD・JST）。AdminCreditLot.expires_on と同じ境界で集計する
   *
   * @generated from field: string expires_on = 1;
   */
  expiresOn: string;

  /**
   * その日を最後に失効する消費可能クレジットの合計
   *
   * @generated from field: int64 amount = 2;
   */
  amount: bigint;
};

/**
 * Describes the message api_proto.v1.AdminCreditUpcomingExpiration.
 * Use `create(AdminCreditUpcomingExpirationSchema)` to create a new message.
 */
export const AdminCreditUpcomingExpirationSchema: GenMessage<AdminCreditUpcomingExpiration> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_credit, 5);

/**
 * @generated from message api_proto.v1.ListCompanyCreditLedgerEntriesRequest
 */
export type ListCompanyCreditLedgerEntriesRequest = Message<"api_proto.v1.ListCompanyCreditLedgerEntriesRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * 既定20・上限100
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * 前ページのnext_cursor。先頭ページは空文字
   *
   * @generated from field: string cursor = 3;
   */
  cursor: string;
};

/**
 * Describes the message api_proto.v1.ListCompanyCreditLedgerEntriesRequest.
 * Use `create(ListCompanyCreditLedgerEntriesRequestSchema)` to create a new message.
 */
export const ListCompanyCreditLedgerEntriesRequestSchema: GenMessage<ListCompanyCreditLedgerEntriesRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_credit, 6);

/**
 * @generated from message api_proto.v1.ListCompanyCreditLedgerEntriesResponse
 */
export type ListCompanyCreditLedgerEntriesResponse = Message<"api_proto.v1.ListCompanyCreditLedgerEntriesResponse"> & {
  /**
   * occurred_at降順
   *
   * @generated from field: repeated api_proto.v1.AdminCreditLedgerEntry entries = 1;
   */
  entries: AdminCreditLedgerEntry[];

  /**
   * 次ページが無ければ空文字
   *
   * @generated from field: string next_cursor = 2;
   */
  nextCursor: string;
};

/**
 * Describes the message api_proto.v1.ListCompanyCreditLedgerEntriesResponse.
 * Use `create(ListCompanyCreditLedgerEntriesResponseSchema)` to create a new message.
 */
export const ListCompanyCreditLedgerEntriesResponseSchema: GenMessage<ListCompanyCreditLedgerEntriesResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_credit, 7);

/**
 * クレジット台帳イベント1件（付与 / 確定消費 / 失効 / 返還）。
 * 企業画面のCreditLedgerEntryと同じ行に、Admin向けの成果物（target_type / target_id）を足したもの
 *
 * @generated from message api_proto.v1.AdminCreditLedgerEntry
 */
export type AdminCreditLedgerEntry = Message<"api_proto.v1.AdminCreditLedgerEntry"> & {
  /**
   * 発生日時（RFC3339）
   *
   * @generated from field: string occurred_at = 1;
   */
  occurredAt: string;

  /**
   * grant_plan / grant_trial / grant_manual / consume / expire / refund
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * consume / refundは対象機能。grant / expireは専用ロットなら対象機能（汎用ロットは空文字）
   *
   * @generated from field: string permission_code = 3;
   */
  permissionCode: string;

  /**
   * 付与・返還は正、消費・失効は負
   *
   * @generated from field: int64 amount = 4;
   */
  amount: bigint;

  /**
   * consumeのみ（実行スタッフ名）。他は空文字
   *
   * @generated from field: string staff_name = 5;
   */
  staffName: string;

  /**
   * 表示ラベル（例: 月次付与 / AIカラーシミュレーションの実行 / 失効）
   *
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * consume / refundの成果物（credit_holds.target_type / target_id。例: ai_color_image / survey_report）。
   * grant / expireは空文字
   *
   * @generated from field: string target_type = 7;
   */
  targetType: string;

  /**
   * @generated from field: string target_id = 8;
   */
  targetId: string;
};

/**
 * Describes the message api_proto.v1.AdminCreditLedgerEntry.
 * Use `create(AdminCreditLedgerEntrySchema)` to create a new message.
 */
export const AdminCreditLedgerEntrySchema: GenMessage<AdminCreditLedgerEntry> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_credit, 8);

